var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { getSalesforceAuthenticationUri } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let SalesforceConfigCard = class SalesforceConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.domainUrl = localStorage.getItem('domainUrlSalesforce') || '';
        this.openModal = false;
        this.disabledField = false;
        this.enabledBtn = false;
        this.loadResults = false;
        this.waitingForUriGeneration = false;
        this.crmIcon = 'statics/images/logos/salesforce-logo.webp';
        this.companyFields = [
            'Razão Social/Nome Fantasia',
            'CNPJ',
            'Setor',
            'Endereço',
            'Cidade',
            'Estado',
            'País',
            'Telefones',
            'Emails',
            'CNAE Primário',
            'CNAEs Secundários',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Funcionários da Unidade CNPJ',
            'Quadro Societário',
            'Emails Principais',
            'Telefones Principais',
        ];
        this.decisorFields = [
            'Nome',
            'Cargo',
            'Departamento',
            'E-mail',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Professional, Enterprise ou Unlimited.',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Superadministrador ou usuário que possa criar e editar empresas e contatos.',
            },
            {
                question: 'Onde ficam os dados das empresas e contatos?',
                answer: 'Clique no iniciador de aplicativos (um cubo ao lado do nome "Configuração"), no campo de pesquisa digite "Leads" e clique na opção de Leads.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador não irá exportar a mesma empresa se detectar que já existe uma com o mesmo nome',
            },
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('salesforce');
    }
    domainUrlSaved() {
        const domainUrl = localStorage.getItem('domainUrlSalesforce');
        return !!domainUrl && domainUrl != '';
    }
    handleOpenModal() {
        return (this.openModal = true);
    }
    // async saveDomainUrl() {
    //   this.loadResults = true
    //   const token = localStorage.getItem('tokenSalesForce')
    //   try {
    //     const validDomainUrl = await Vue.axios.post(
    //       `${getApiExportBaseUrl()}/user/salesforce/validate_domain_url?skip_handle_error`,
    //       {
    //         domainUrl: this.domainUrl,
    //         token,
    //       }
    //     )
    //     if (validDomainUrl && validDomainUrl.status == 201) {
    //       localStorage.setItem('domainUrlSalesforce', this.domainUrl)
    //       NotificationService.success(
    //         'Sucesso',
    //         'URL de domínio salvo com sucesso!'
    //       )
    //     }
    //   } catch (err) {
    //     NotificationService.error(
    //       'Erro',
    //       'URL de domínio inválida ou token de autenticação expirado!'
    //     )
    //   }
    //   this.loadResults = false
    // }
    removeDomainUrl() {
        localStorage.removeItem('domainUrlSalesforce');
        this.domainUrl = '';
    }
    handleData(data) {
        return Object.keys(data);
    }
    async handleBtnClick() {
        this.waitingForUriGeneration = true;
        try {
            this.enabledBtn = true;
            const redirect_uri = `${window.location.origin}/crm/salesforce/callback`;
            const response = await getSalesforceAuthenticationUri({ redirect_uri });
            window.open(response.data.uri, 'popup', 'height=525,width=600');
        }
        catch (e) {
            NotificationService.error('Error', 'Não foi possível gerar a janela de autenticação');
            console.log(e);
        }
        this.waitingForUriGeneration = false;
    }
};
SalesforceConfigCard = __decorate([
    Component({
        name: 'SalesforceConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], SalesforceConfigCard);
export default SalesforceConfigCard;
